// hooks/useEntityAnalytics.ts
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { pushToGTMDataLayer } from 'Utils/analytics';
import { ENTITY_PROFILE_CONSTANTS } from '../constants';
import { EntityDetails } from './useEntityDetailsLoader';

/**
 * Hook to handle analytics for the entity profile
 * @param entityDetails - The entity details to be used for analytics
 */
export const useEntityAnalytics = (entityDetails: EntityDetails | null) => {
  const { ANALYTICS_EVENTS } = ENTITY_PROFILE_CONSTANTS;

  useEffect(() => {
    if (entityDetails) {
      const { unsavedContact } = entityDetails;

      pushToGTMDataLayer(ANALYTICS_EVENTS.PROFILE_VIEW, {
        profileType: isEmpty(unsavedContact) ? 'Person' : 'Contact',
      });
    }
  }, [ANALYTICS_EVENTS.PROFILE_VIEW, entityDetails]);
};
